import Lottie from 'lottie-light-react'

import animationData from '../../../assets/loading.json'

import './loading.scss'

const Loading = ({open}) => {
    return <div className={'loading'}>
        {(open) &&
            <div className={'div-loading'}>
                <Lottie
                animationData={animationData}
                className={'lottie-loading'}
            />
            </div>
        }
    </div>
}

export default Loading
